<template>
  <v-layout class="justify-center align-center">
    <v-btn
      color="white"
      class="text-capitalize mt-2"
      elevation="0"
      rounded
      large
      icon
      style=""
      @click="$emit('clickButton', {})"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  props: {},
  data: () => ({}),
  watch: {},
  computed: {},
};
</script>

<style></style>
